<template>
  <div>
    <select :disabled="!date" v-model="timeInterval">
      <option disabled :value="null">
        {{ trans("checkout.choice_time_interval") }}
      </option>
      <option v-for="time in times" :key="time" :value="time">{{ time }}</option>
    </select>
  </div>
</template>

<script>
export default {
  mixins: [],
  components: {},
  props: {
    value: {
      required: true,
    },
    datesTimes: {
      type: Object,
      required: true,
    },
    date: {
      required: true,
    },
  },
  data() {
    return {
      timeInterval: this.value,
    };
  },
  created() {},
  beforeMount() {},
  mounted() {},
  watch: {
    date(newValue) {
      this.timeInterval = null;
    },
    timeInterval(newValue) {
      this.$emit("input", newValue);
    },
  },
  computed: {
    times() {
      if (this.date) {
        return this.datesTimes[this.date] || [];
      }
      return [];
    },
  },
  methods: {},
};
</script>
